import {
  useApproveJournalEntry,
  useDeclineJournalEntry,
  useVoidJournalEntry,
  useCopyJournalEntry,
} from "../../../hooks/api/mutations/useAccounting";
import { ToastContext } from "../../../hooks/context";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";

const useJournalEntryDetails = ({ reference, refetchJournalEntryDetails }) => {
  const approveJournalEntryMutation = useApproveJournalEntry();
  const declineJournalEntryMutation = useDeclineJournalEntry();
  const voidJournalEntryMutation = useVoidJournalEntry();
  const copyJournalEntryMutation = useCopyJournalEntry();
  const triggerToast = useContext(ToastContext);
  const navigate = useNavigate();

  const handleApproveJournalEntry = () => {
    approveJournalEntryMutation.mutate(
      { reference },
      {
        onSuccess: () => {
          triggerToast("Successfully approved this journal entry", "success");
          refetchJournalEntryDetails();
        },
      },
    );
  };

  const handleDeclineJournalEntry = () => {
    declineJournalEntryMutation.mutate(
      { reference },
      {
        onSuccess: () => {
          triggerToast("Successfully declined this journal entry", "success");
          refetchJournalEntryDetails();
        },
      },
    );
  };

  const handleVoidJournalEntry = () => {
    if (voidJournalEntryMutation.isLoading) return;
    voidJournalEntryMutation.mutate(
      { reference },
      {
        onSuccess: () => {
          triggerToast("Successfully voided this journal entry", "success");
          refetchJournalEntryDetails();
        },
      },
    );
  };

  const handleCopyJournalEntry = () => {
    if (copyJournalEntryMutation.isLoading) return;
    copyJournalEntryMutation.mutate(
      { reference },
      {
        onSuccess: (response) => {
          triggerToast("Successfully copied this journal entry", "success");
          navigate(
            `${pathConstants.ACCOUNTING_EDIT_JOURNAL_ENTRY({ reference: response?.data?.data?.reference })}`,
          );
        },
      },
    );
  };

  return {
    approveJournalEntryMutation,
    declineJournalEntryMutation,
    voidJournalEntryMutation,
    copyJournalEntryMutation,
    handleApproveJournalEntry,
    handleDeclineJournalEntry,
    handleVoidJournalEntry,
    handleCopyJournalEntry,
  };
};

export default useJournalEntryDetails;
